import React from 'react'
import {connect} from 'react-redux'
import { Button, Dialog } from 'react-weui'
import axios from 'axios'
import qs from 'qs'

import { Page, Preload, WKError } from '../../components'
import {getJsonFromUrl} from '../../utils';


class LiveroomLecturerAcceptInvitePage extends React.Component {
    constructor() {
        super();

        this.handleConfirm = this.handleConfirm.bind(this);
        this.state = {
            initialized: false,
            buttons: [
                {
                    label: '好的',
                    onClick: () => {
                        this.setState({
                            showAlert: false,
                            showAlertMsg: ''
                        })
                    }
                }
            ],
            showAlert: false,
            showAlertMsg: '',
        }
    }

    handleConfirm() {
        const {liveroom_id} = this.props.params;
        let paramsObject = getJsonFromUrl();

        axios.post(`/api/liveroom/${liveroom_id}/manager/accept_invite`, qs.stringify({
            invite_id: paramsObject.invite_id,
            sign: paramsObject.sign
        })).then((res) => {
            if (res.data.code === 0) {
                this.page.showAlert('恭喜你成为该直播间管理员', () => {
                    window.location = `/liveroom/${liveroom_id}`
                });
            } else {
                this.page.showAlert(res.data.msg)         
                // this.setState({                           //页面黑屏显示弹窗,这里是手动触发，不需要黑屏显示
                //     initialized:false,
                //     showAlert:true,
                //     showAlertMsg: res.data.msg
                // })
            }
        }).catch((e) => {
          this.page.showAlert("接受失败")
        })
    }

    componentDidMount() {
        const {liveroom_id} = this.props.params;
        let paramsObject = getJsonFromUrl();
        axios.post(`/api/liveroom/${liveroom_id}/manager/accept_invite_info`,  qs.stringify({
            invite_id: paramsObject.invite_id,
            sign: paramsObject.sign
        })).then((res) => {
            if (res.data.code === 0) {
                this.setState({initialized: true, liveroom_invite_info: res.data.data.liveroom_invite_info})
            } else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '已被认领，需重新邀请。',
                        href: '/?st=inviter_page_1',
                        btn: '去首页看看'
                    }
                });
            }
        })
    }

    render() {
        const {initialized, liveroom_invite_info} = this.state;
        const {error} = this.props;

        if (error.showError) {
            return (
                <div style={{background: '#fff'}}>
                    <WKError />
                </div>
            )
        }

        if (!initialized) {
            return (
                <div>
                    <Dialog type="ios" buttons={this.state.buttons} show={this.state.showAlert}>
                        {this.state.showAlertMsg}
                    </Dialog>

                    <Preload/>
                </div>
                )
        }

        return (
            <Page parent={this}>

                <div className='wk-inner-page liveroom-setting-accept-page invite'>
                    <div className='lvr-accept-header'>{liveroom_invite_info.share_title}</div>
                    <div className='lvr-accept-content'>{liveroom_invite_info.share_description}</div>
                    <div className='lvr-accept-btn-text'>点击下方按钮，接受邀请</div>
                    <div className='lvr-btn-area'>
                        <Button onClick={this.handleConfirm}>接受</Button>
                    </div>
                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    error: state.error
}))(LiveroomLecturerAcceptInvitePage)



// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/LiveroomLecturerAcceptInvitePage.js